import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { components } from 'react-select';
import { customersCountriesList } from 'waldur-js-client';

import { SelectOption } from 'waldur-ui';

import { STALE_TIME } from '@/core/constants';
import { CountryFlag } from '@/marketplace/common/CountryFlag';

import { WindowedSelect } from './select';
import { FormField } from './types';

interface CountryOption {
  label: string;
  value: string;
}

const CountryRenderer = ({ value, label }: CountryOption) => (
  <span>
    <CountryFlag countryCode={value} fontSize={20} /> {label}
  </span>
);

const Option: FC<any> = (props) => (
  <SelectOption {...props}>
    <CountryRenderer {...props.data} />
  </SelectOption>
);

const SingleValue: FC<any> = (props) => (
  <components.SingleValue {...props}>
    <CountryRenderer {...props.data} />
  </components.SingleValue>
);

interface CountrySelectFieldProps extends FormField {
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
}

export const CountrySelectField: FC<CountrySelectFieldProps> = ({
  input,
  placeholder,
  isClearable = true,
  isDisabled = false,
}) => {
  const { isLoading, data } = useQuery({
    queryKey: ['countries'],
    queryFn: () => customersCountriesList().then((r) => r.data),
    staleTime: STALE_TIME,
  });

  return (
    <WindowedSelect
      value={
        input.value
          ? data?.find((option) => option.value === input.value) || null
          : null
      }
      onChange={(option: CountryOption | null) => {
        input.onChange(option?.value || null);
        input.onBlur();
      }}
      onBlur={() => input.onBlur()}
      components={{ Option, SingleValue }}
      placeholder={placeholder}
      getOptionLabel={(option: CountryOption) => option.label}
      getOptionValue={(option: CountryOption) => option.value}
      options={data || []}
      isLoading={isLoading}
      isClearable={isClearable}
      isDisabled={isDisabled}
    />
  );
};
